import BuildingType from '@/roc/building/BuildingType';
import ProductionCurrency from '@/roc/effects/Production/ProductionCurrency';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import Effects from '@/roc/effects/Effects';
import ProductionQueue from '@/roc/effects/Production/ProductionQueue';
import ProductionWorkforce from '@/roc/effects/Production/ProductionWorkforce';
import ProductionCost from '@/roc/effects/Production/ProductionCost';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const AirshipExhibit = {
  id: '123',
  name: 'Airship Exhibit',
  width: 3,
  height: 2,
  type: BuildingType.COLLECTABLE,
  era: 'stoneAge',
  icon: 'Airship_Exhibit',
  minLevel: 1,
  maxLevel: 40,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Airship_Exhibit',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new ProductionQueue(
      ProductionWorkforce.asFlat(4),
      [
        ProductionCost.asFlat(5).withCurrency(ProductionCurrency.RESEARCH_POINTS),
      ],
      ProductionDuration.asHourMinutePerLevel([
        [24,  0], [23, 50], [23, 40], [23, 30], [23, 20],
        [23, 10], [23,  0], [22, 50], [22, 40], [22, 30],
        [21, 58], [21, 27], [20, 59], [20, 33], [20, 10],
        [19, 48], [19, 28], [19,  9], [18, 52], [18, 36],
        [18, 21], [18,  7], [17, 54], [17, 42], [17, 30],
        [17, 19], [17,  9], [16, 59], [16, 50], [16, 41],
        [16, 33], [16, 25], [16, 17], [16, 10], [16,  3],
        [15, 56], [15, 50], [15, 44], [15, 38], [15, 33],
      ]),
      ProductionOutput.asFlat(1).withOutput(ProductionOutputType.RANDOM_MERCENARY_COMMANDER),
    )
  ]),
};

export default AirshipExhibit;
